import { render, staticRenderFns } from "./validation-document.vue?vue&type=template&id=c8089052&scoped=true"
import script from "./validation-document.vue?vue&type=script&lang=js"
export * from "./validation-document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8089052",
  null
  
)

export default component.exports